import { FC } from 'react'
import { useTranslate } from 'react-admin'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { DataStoreDeleteNodeData, WorkflowNodeData } from '../types'
import ExpressionTextField from '../autocomplete/ExpressionTextField'

interface DataStoreDeleteConfigProps {
  data: DataStoreDeleteNodeData
  onUpdate: (data: Partial<WorkflowNodeData>) => void
}

const DataStoreDeleteConfig: FC<DataStoreDeleteConfigProps> = ({ data, onUpdate }) => {
  const translate = useTranslate()
  const recordId = (data.recordId ?? '').trim()
  const warningText = !recordId ? translate('workflow.node.dataStoreMissingRecordId') : null

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {warningText && <Alert severity="warning">{warningText}</Alert>}

      <ExpressionTextField
        label={translate('workflow.config.label')}
        value={data.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        size="small"
        fullWidth
      />

      <ExpressionTextField
        required
        error={!recordId}
        label={translate('workflow.config.dataStoreRecordId')}
        value={data.recordId ?? ''}
        onChange={(e) => onUpdate({ recordId: e.target.value })}
        size="small"
        fullWidth
        placeholder="{{ trigger.id }}"
        helperText={translate('workflow.config.dataStoreRecordIdHelp')}
        InputProps={{ sx: { fontFamily: '"SF Mono", "Fira Code", monospace', fontSize: 12 } }}
      />
    </Box>
  )
}

export default DataStoreDeleteConfig
